export const getText = (
  from: number | null,
  to: number | null,
  isOutOf?: boolean
): string => {
  if (!from && !to) {
    return '-'
  }
  if (from && to) {
    if (isOutOf) {
      return `${to}+`
    }
    return `${from}-${to}`
  }
  return `${from}`
}
